import { applyFilters, doRequest } from "./helpers";

export default class TableExportService {
  static async exportTable(tableName, filters = {}, savedSearchName = null) {
    let path = `/export/${tableName}`;
    if (savedSearchName) {
      filters = { ...filters, saved_search_name: savedSearchName };
    }
    path = applyFilters(filters, path);
    return doRequest("GET", path);
  }

  static async exportCustomTable(slug, format = "xlsx", filters = {}) {
    const path = applyFilters(
      { ...filters, format },
      `/custom_tables/${slug}/export`
    );
    const resp = await doRequest("GET", path);
    // DownloadModal expects truthy === success; the BE returns
    // ``{data_job_id: <int>}`` (the DataJob primary key, suitable for
    // the standard poll endpoint) but here we collapse to ``true`` for
    // the existing modal flow.
    return resp && resp.data_job_id ? true : resp;
  }
}
